<app-breadcrumb
  [title]="'notifications.center.pageTitle' | translate"
  [items]="['notifications.breadcrumbDashboard' | translate]"
  [active_item]="'notifications.center.pageTitle' | translate">
</app-breadcrumb>

<div class="container-fluid notification-center">
  <!-- Hub tabs: inbox | settings | company requests -->
  <ul class="notification-center__tabs" role="tablist">
    <li>
      <button type="button" class="notification-center__tab notification-center__tab--active">
        <app-feather-icons icon="inbox"></app-feather-icons>
        {{ 'notifications.center.tabInbox' | translate }}
        <span class="notification-center__tab-badge" *ngIf="unread > 0">{{ unread > 99 ? '99+' : unread }}</span>
      </button>
    </li>
    <li>
      <button type="button" class="notification-center__tab" (click)="goToSettings()">
        <app-feather-icons icon="bell"></app-feather-icons>
        {{ 'notifications.pushSettingsTab' | translate }}
      </button>
    </li>
    <li *ngIf="isOfficeUser">
      <button type="button" class="notification-center__tab" (click)="goToRequests()">
        <app-feather-icons icon="briefcase"></app-feather-icons>
        {{ 'notifications.companyRequestsTab' | translate }}
        <span class="notification-center__tab-badge" *ngIf="companyRequestsCount > 0">{{ companyRequestsCount }}</span>
      </button>
    </li>
  </ul>

  <!-- Stats row -->
  <div class="notification-center__stats">
    <div class="notification-center__stat">
      <span class="notification-center__stat-value">{{ total }}</span>
      <span class="notification-center__stat-label">{{ 'notifications.center.statTotal' | translate }}</span>
    </div>
    <div class="notification-center__stat notification-center__stat--unread">
      <span class="notification-center__stat-value">{{ unread }}</span>
      <span class="notification-center__stat-label">{{ 'notifications.center.statUnread' | translate }}</span>
    </div>
  </div>

  <div class="card notification-center__card">
    <!-- Filters -->
    <div class="notification-center__toolbar">
      <div class="notification-center__filters">
        <div class="notification-center__filter">
          <label class="notification-center__filter-label">{{ 'notifications.center.filterStatus' | translate }}</label>
          <select class="notification-center__select" [(ngModel)]="readFilter" (change)="applyFilters()">
            <option value="">{{ 'notifications.center.filterAll' | translate }}</option>
            <option value="unread">{{ 'notifications.center.filterUnread' | translate }}</option>
            <option value="read">{{ 'notifications.center.filterRead' | translate }}</option>
          </select>
        </div>

        <div class="notification-center__filter">
          <label class="notification-center__filter-label">{{ 'notifications.center.filterTypeLabel' | translate }}</label>
          <select class="notification-center__select" [(ngModel)]="typeFilter" (change)="applyFilters()">
            <option value="">{{ 'notifications.center.filterTypeAll' | translate }}</option>
            <option *ngFor="let type of typeOptions" [value]="type">{{ typeLabel(type) }}</option>
          </select>
        </div>

        <div class="notification-center__filter">
          <label class="notification-center__filter-label">{{ 'notifications.center.filterSourceLabel' | translate }}</label>
          <select class="notification-center__select" [(ngModel)]="sourceFilter" (change)="applyFilters()">
            <option value="">{{ 'notifications.center.filterSourceAll' | translate }}</option>
            <option *ngFor="let source of sourceOptions" [value]="source">{{ sourceLabel(source) }}</option>
          </select>
        </div>

        <button
          type="button"
          class="notification-center__clear-btn"
          *ngIf="hasActiveFilters"
          (click)="clearFilters()"
        >
          {{ 'notifications.center.clearFilters' | translate }}
        </button>
      </div>

      <button
        type="button"
        class="btn btn-sm notification-center__mark-all"
        *ngIf="unread > 0"
        (click)="markAllRead()"
      >
        <app-feather-icons icon="check-circle"></app-feather-icons>
        {{ 'notifications.logMarkAllRead' | translate }}
      </button>
    </div>

    <div class="card-body p-0">
      <div class="notification-center__loading px-3 py-4 text-center" *ngIf="loading && items.length === 0">
        <span class="spinner-border spinner-border-sm text-secondary"></span>
      </div>

      <div class="notification-center__error px-3 py-4 text-center" *ngIf="!loading && error">
        <app-feather-icons icon="alert-circle"></app-feather-icons>
        <p>{{ 'notifications.logError' | translate }} ({{ error }})</p>
        <button type="button" class="btn btn-sm btn-outline-secondary" (click)="loadPage(1, true)">
          {{ 'notifications.logRetry' | translate }}
        </button>
      </div>

      <div class="notification-center__empty px-3 py-5 text-center" *ngIf="!loading && !error && items.length === 0">
        <div class="notification-center__empty-icon">
          <app-feather-icons icon="inbox"></app-feather-icons>
        </div>
        <p class="notification-center__empty-title">{{ 'notifications.logEmpty' | translate }}</p>
        <p class="notification-center__empty-sub">{{ 'notifications.center.emptyHint' | translate }}</p>
      </div>

      <div class="notification-center__list" *ngIf="items.length > 0">
        <div
          class="notification-center__item"
          [class.notification-center__item--unread]="!item.is_read"
          *ngFor="let item of items; trackBy: trackById"
          (click)="onItemClick(item)"
          role="button"
          tabindex="0"
        >
          <div class="notification-center__item-icon" [class.notification-center__item-icon--unread]="!item.is_read">
            <app-feather-icons [icon]="getTypeIcon(item.notification_type)"></app-feather-icons>
          </div>

          <div class="notification-center__item-body">
            <div class="notification-center__item-head">
              <p class="notification-center__item-title">{{ item.title }}</p>
              <span class="notification-center__item-dot" *ngIf="!item.is_read"></span>
            </div>
            <p class="notification-center__item-msg">{{ item.message }}</p>
            <div class="notification-center__item-meta">
              <span class="notification-center__chip notification-center__chip--type">{{ typeLabel(item.notification_type) }}</span>
              <span class="notification-center__chip notification-center__chip--source">{{ sourceLabel(item.notification_source) }}</span>
              <span class="notification-center__item-time">{{ item.created_at | date: 'dd/MM/yyyy HH:mm' }}</span>
            </div>
          </div>

          <div class="notification-center__item-arrow">
            <app-feather-icons icon="chevron-left"></app-feather-icons>
          </div>
        </div>
      </div>

      <div class="notification-center__footer" *ngIf="hasMore">
        <button type="button" class="btn btn-sm notification-center__load-more" [disabled]="loading" (click)="loadMore()">
          <span *ngIf="loading" class="spinner-border spinner-border-sm me-1"></span>
          {{ 'notifications.logLoadMore' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
